// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are Navigateed to the login page.
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkTokenValidity } from "utils/auth";
import { useDispatch } from "react-redux";
import { logoutUser } from "actions/users";

const PrivateRoute = ({ children }) => {
  // Add your own authentication on the below line.
  const [isValidToken, setIsValidToken] = useState(null);
  const activeUser = useSelector((state) => state.users.activeUser);
  const isLoggedIn = activeUser !== null;
  const dispatch = useDispatch();

  useEffect(() => {
    async function checkToken() {
      const isValid = isLoggedIn && (await checkTokenValidity());
      setIsValidToken(isValid);
      if (!isValid) {
        dispatch(logoutUser());
      }
    }
    checkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isValidToken === null) {
    return <div>Loading...</div>;
  }

  const currentPath = window.location.pathname;
  if (
    activeUser?.user_type?.match(/client/) &&
    !currentPath.match(/^\/client/)
  ) {
    return <Navigate to="/client/" replace={true} />;
  }

  if (!isValidToken) {
    localStorage.setItem("redirectPath", window.location.pathname);
    return <Navigate to="/login" replace={true} />;
  }

  return children;
};

export default PrivateRoute;
